import { ReactComponent as CloseIcon } from '@icons/close.svg'
import { modifier, tablet } from '@styles/mixins'
import { colors, grid, typography } from '@styles/vars'
import React from 'react'
import { Link } from 'react-router-dom'
import { Link as ScrollLink } from "react-scroll"
import styled, { css } from 'styled-components'
import Grid from './Grid'
import Sidepanel, { BackButtonProps } from './Sidepanel'

function Sidemenu({ children }: SidemenuProps) {
    return (
        <Sidepanel options={{ back: SidemenuClose }}>
            <Grid gap="30px">
                {children}
            </Grid>
        </Sidepanel>
    )
}

Sidemenu.Item = React.memo(SidemenuItem)

export default Sidemenu 

// COMPONENTS
function SidemenuItem({ onClick, to = "", smooth, condition = true, label, active, count, newTab }: SidemenuItemProps) {
    if (!condition) return null
    const content = <LinkWrapper>{label}{Boolean(count) && <CountWrapper>{count}</CountWrapper>}</LinkWrapper>
    return (
        <SidemenuItemWrapper active={active}>
            {smooth 
                ? <ScrollLink to={to} smooth={true} onClick={onClick}>{content}</ScrollLink> 
                : <Link to={to} onClick={onClick} target={newTab ? "_blank" : undefined}>{content}</Link>}
        </SidemenuItemWrapper>
    )
}

function SidemenuClose({ close }: BackButtonProps) {
    return <SidemenuCloseWrapper onClick={close}><CloseIcon /> Close</SidemenuCloseWrapper>
}

// STYLES
const LinkWrapper = styled.div`
    display: flex;
    align-items: center;
`

const CountWrapper = styled.div`
    background: ${colors.white};
    width: 30px;
    flex-shrink: 0;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.black};
    border: 1px solid ${colors.border};
    margin-left: 15px;
    font-size: 16px;
`

const SidemenuItemWrapper = styled.div<{ active?: boolean }>`
    display: flex;
    a {
        cursor: pointer;
        text-decoration: none;
        font-size: ${typography.sizes.h3};
        font-weight: 700;

        ${modifier("active", css`
            border-left: 10px solid ${colors.black};
            margin-left: -${grid.margins.phone};
            padding-left: calc( ${grid.margins.phone} - 10px );

            ${tablet(css`
                margin-left: -${grid.margins.tablet};
                padding-left: calc( ${grid.margins.tablet} - 10px );
            `)}
        `)}
    }
`

const SidemenuCloseWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: 600;
    color: ${colors.darkGrey};
    opacity: 0.8;

    svg {
        fill: ${colors.darkGrey};
        margin-right: 5px;
    }
`

// TYPES
interface SidemenuProps {
    children: React.ReactNode
}

interface SidemenuItemProps {
    onClick?(): void
    to?: string
    label: string
    condition?: boolean
    smooth?: boolean
    active?: boolean
    count?: number
    newTab?: boolean
}